import { render, staticRenderFns } from "./test4-1.vue?vue&type=template&id=10929e0f&scoped=true"
import script from "./test4-1.vue?vue&type=script&lang=js"
export * from "./test4-1.vue?vue&type=script&lang=js"
import style0 from "./test4-1.vue?vue&type=style&index=0&id=10929e0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10929e0f",
  null
  
)

export default component.exports